import { useEffect, useRef } from 'react';

// Un seul IntersectionObserver partagé entre tous les composants
let sharedObserver = null;
const observedElements = new Map();

function getSharedObserver(threshold, rootMargin) {
  if (!sharedObserver) {
    sharedObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            sharedObserver.unobserve(entry.target);
            observedElements.delete(entry.target);
          }
        });
      },
      { threshold, rootMargin }
    );
  }
  return sharedObserver;
}

export function useScrollReveal(options = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = getSharedObserver(
      options.threshold || 0.1,
      options.rootMargin || '0px 0px -60px 0px'
    );
    observer.observe(el);
    observedElements.set(el, true);

    return () => {
      observer.unobserve(el);
      observedElements.delete(el);
    };
  }, [options.threshold, options.rootMargin]);

  return ref;
}

export function useAutoScrollReveal() {
  useEffect(() => {
    const observer = getSharedObserver(0.1, '0px 0px -60px 0px');
    const elements = document.querySelectorAll('.scroll-reveal:not(.revealed)');
    const tracked = [];
    elements.forEach((el) => {
      if (!observedElements.has(el)) {
        observer.observe(el);
        observedElements.set(el, true);
        tracked.push(el);
      }
    });
    return () => {
      tracked.forEach((el) => {
        observer.unobserve(el);
        observedElements.delete(el);
      });
    };
  }, []);
}
